module.exports = __webpack_public_path__ + "img/5-5.40bebc99.svg";